import moment from 'moment'
import { orderBy, findIndex } from 'lodash'

import { isKeyword, isNumeric, sanitizeDomain } from './functions'

const getDateExpression = (range) => {
  const dateExpressions = {
    daily: 'YYYY-MM-DD',
    weekly: 'YYYY-MM-W',
    montly: 'YYYY-MM',
  }
  return dateExpressions[range] || dateExpressions.daily
}

export const perDateEntry = (data, idField, range = 'daily') => {
  if (Array.isArray(data) && data.length) {
    const dateExpression = getDateExpression(range)
    const dataMap = {}
    data.forEach((item) => {
      const id = item[idField]
      dataMap[id] = dataMap[id] ? [...dataMap[id], item] : [item]
    })

    Object.entries(dataMap).forEach(([id, payload]) => {
      dataMap[id] = payload.sort((a, b) => b.timestamp - a.timestamp)
    })

    const filtered = {}
    Object.values(dataMap).forEach((kwEntry) => {
      kwEntry.forEach((entry) => {
        if (entry) {
          const date = moment(entry.timestamp * 1000).format(dateExpression)
          entry.date = date
          filtered[date] = filtered[date] ? [...filtered[date], entry] : [entry]
          filtered[date] = orderBy(filtered[date], ['timestamp'], ['desc'])
        }
      })
    })
    const values = orderBy(
      Object.values(filtered),
      [(entry) => (entry[0] || {}).timestamp],
      ['asc'],
    )
    while (Array.isArray(values) && values.length < 2) {
      values.push(values[values.length - 1])
    }
    return values
  }
  return []
}

export const attachKeyword = (previousConfig, keyword, loc_id, lang) => {
  if (!previousConfig[keyword]) {
    previousConfig[keyword] = [{ loc_id, lang }]
  } else if (
    !previousConfig[keyword].some(
      (config) => config.loc_id === loc_id && config.lang === lang,
    )
  )
    previousConfig[keyword] = [...previousConfig[keyword], { loc_id, lang }]
  return previousConfig
}

export const kwsFromCSV = (parsed) => {
  const header = parsed.shift()
  if (header) {
    const hasKeywordInColumn = (column) => {
      const lowerCasedColumn = column.toLowerCase()
      return (
        lowerCasedColumn.indexOf('keyword') > -1 ||
        lowerCasedColumn.indexOf('keywords') > -1
      )
    }
    let index = findIndex(header, (col) => {
      const lowerCasedColumn = col.toLowerCase()
      return (
        lowerCasedColumn === 'keyword' ||
        lowerCasedColumn === 'keywords' ||
        hasKeywordInColumn(col)
      )
    })

    if (index === -1) {
      index = findIndex(header, (col) => isKeyword(col) && !isNumeric(col))
      parsed.unshift(header)
    }

    if (index !== -1) {
      return parsed.map((row) => row[index]?.toLowerCase().trim())
    }
  }
  return []
}

export const filterNewKeywords = (keywords, attached, limit) =>
  (Array.isArray(keywords) ? keywords : [keywords])
    .filter(
      (kw) => !!kw && !attached.some((addedKeyword) => addedKeyword === kw),
    )
    .slice(0, limit)

export const filterNewCompetitors = (competitors, attached) =>
  competitors.filter(
    (c) =>
      !!c &&
      !attached.some(
        (addedCompetitors) =>
          addedCompetitors.domain === sanitizeDomain(c.domain),
      ),
  )

export const getProjectDefaultRange = (createdAt, updatedAt) => {
  const fixedDate = updatedAt ? updatedAt * 1000 : new Date().valueOf()
  const updatedAtDate = moment(fixedDate).endOf('day')
  const createdAtDate = moment(createdAt * 1000).startOf('day')
  const before30Days = moment().subtract(30, 'days').startOf('day')
  const dateRange = [before30Days.toDate(), updatedAtDate.toDate()]

  const today = moment().endOf('day')
  const diffYears = today.startOf('year').diff(createdAtDate, 'year')

  const rangeOptions = ['all_time']

  if (diffYears >= 3) rangeOptions.unshift('last3years')
  rangeOptions.unshift('last12months')
  rangeOptions.unshift('last6months')
  rangeOptions.unshift('last3months')
  rangeOptions.unshift('lastmonth')
  rangeOptions.unshift('last30days')
  rangeOptions.unshift('last2weeks')

  const rangeType = 'last30days'

  return { dateRange, rangeType, rangeOptions }
}
